/**
 * Shared add-to-cart for AMZ product cards (home, collection, search, related).
 */
(function () {
  if (window.__amzCardCartBound) return;
  window.__amzCardCartBound = true;

  function ensureToast() {
    var toast = document.getElementById('amz-card-toast');
    if (toast) return toast;
    toast = document.createElement('div');
    toast.id = 'amz-card-toast';
    toast.className = 'amz-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = 'Added to cart';
    document.body.appendChild(toast);
    return toast;
  }

  function ping(msg) {
    var toast = ensureToast();
    toast.textContent = msg;
    toast.classList.add('is-on');
    setTimeout(function () {
      toast.classList.remove('is-on');
    }, 2200);
  }

  function getCartSections() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function dispatchCartEvents(cartData) {
    var events = ['cart:refresh', 'cart:updated', 'cart:item-added', 'cart:update'];
    events.forEach(function (name) {
      document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: cartData }));
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: cartData }));
    });
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'amz-card-cart',
        productVariantId: cartData && cartData.item && (cartData.item.variant_id || cartData.item.id),
        cartData: cartData.cart || cartData
      });
    }
  }

  function updateCartIconBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var section = parsed.querySelector('.shopify-section') || parsed.body.firstElementChild;
    if (section) bubble.innerHTML = section.innerHTML;
  }

  function refreshDawnDrawer(addResponse) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;

    drawer.classList.remove('is-empty');

    if (addResponse && addResponse.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(addResponse);
      return true;
    }

    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        if (typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: sections });
        } else {
          var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var inner = parsed.querySelector('.drawer__inner');
          var current = drawer.querySelector('.drawer__inner');
          if (inner && current) current.innerHTML = inner.innerHTML;
        }
        updateCartIconBubble(sections);
      })
      .then(function () {
        return true;
      })
      .catch(function () {
        return false;
      });
  }

  function openAvadaDrawer(cartData) {
    dispatchCartEvents(cartData);
    window.setTimeout(function () {
      if (typeof window.aovCartDrawerRefresh === 'function') {
        window.aovCartDrawerRefresh();
      } else if (window.AVADA_CART_DRAWER && typeof window.AVADA_CART_DRAWER.fetchCart === 'function') {
        window.AVADA_CART_DRAWER.fetchCart();
      }
    }, 120);
  }

  function afterAddToCart(addResponse) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    if (addResponse && addResponse.sections) {
      updateCartIconBubble(addResponse.sections);
    }

    return fetch(root + 'cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var payload = { cart: cart, item: addResponse, open: true };
        dispatchCartEvents(payload);

        if (window.AVADA_CART_DRAWER && window.AVADA_CART_DRAWER.settings && window.AVADA_CART_DRAWER.settings.status) {
          openAvadaDrawer(payload);
          return;
        }

        var dawnResult = refreshDawnDrawer(addResponse);
        if (dawnResult && typeof dawnResult.then === 'function') {
          return dawnResult;
        }
        if (!dawnResult) {
          ping('Added to cart');
        }
      });
  }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-amz-qty-minus]');
    var plus = e.target.closest('[data-amz-qty-plus]');
    if (minus || plus) {
      e.preventDefault();
      e.stopPropagation();
      var card = e.target.closest('[data-amz-variant-id]');
      if (card && window.AmzHomeCartQty && typeof window.AmzHomeCartQty.step === 'function') {
        window.AmzHomeCartQty.step(card, plus ? 1 : -1);
      }
      return;
    }

    var btn = e.target.closest('.amz-add');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) {
      window.location.href = btn.getAttribute('data-product-url');
      return;
    }
    var label = btn.textContent;
    btn.classList.add('is-busy');
    btn.textContent = 'Adding…';

    var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var sections = getCartSections();
    var formData = new FormData();
    formData.append('id', id);
    formData.append('quantity', '1');
    formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'add failed');
        btn.classList.remove('is-busy');
        btn.textContent = label;
        return afterAddToCart(data).then(function () {
          if (window.AmzHomeCartQty && typeof window.AmzHomeCartQty.refresh === 'function') {
            return window.AmzHomeCartQty.refresh();
          }
        });
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        btn.textContent = label;
        ping('Could not add — try the product page');
      });
  });
})();
